/* eslint-disable */ 
// this code manipulates the date boxes in the multi-fields search. For the script that contols the search results date boxes, 
// look in the results.twig file

$(function () {
    var dateFormat = 'dd/mm/yy',
        searchFrom = $('#search_from')
            .datepicker({
                defaultDate: '+1w',
                showButtonPanel: true,
                changeMonth: true,
                changeYear: true,
                numberOfMonths: 1,
                showOtherMonths: true,
                selectOtherMonths: true,
                dateFormat: dateFormat,
                yearRange: '1800:' + new Date().getFullYear(), // Year range from 1900 to current year,
                onChangeMonthYear: function(year, month, inst) {
                    console.log('Fields Date Changing' + year + month);
                    setTimeout(() => {
                        const selectedDate = $(this).datepicker('getDate');
                        if (selectedDate) {
                            $('#search_from').val($.datepicker.formatDate(dateFormat, new Date(year, month - 1, 1)));
                        }
                    }, 0);
                }, 
            })
            .on('change', function () {
                searchFrom.datepicker('option', 'minDate', getDate(this));
            }),
        searchTo = $('#search_to')
            .datepicker({
                defaultDate: '+1w',
                showButtonPanel: true,
                changeMonth: true,
                changeYear: true,
                numberOfMonths: 1,
                showOtherMonths: true,
                selectOtherMonths: true,
                dateFormat: dateFormat,
                yearRange: '1800:' + new Date().getFullYear(), // Year range from 1900 to current year,
                // added onChangeMonthYear to extend functionality of datebox, it will now select and finalise a date by just clicking year or month
                // previously it would only change on alteration of day date.

                onChangeMonthYear: function(year, month, inst) {
                    setTimeout(() => {
                        const selectedDate = $(this).datepicker('getDate');
                        if (selectedDate) {
                            $('#search_to').val($.datepicker.formatDate(dateFormat, new Date(year, month - 1, 1)));
                        }
                    }, 0);
                }, 
            })
            .on('change', function () {
                searchTo.datepicker('option', 'maxDate', getDate(this));
            });

            // Remove the 'Done' button
            $(".ui-datepicker-close").remove();

    function getDate(element) {
        var date;
        try {
            date = $.datepicker.parseDate(dateFormat, element.value);
        } catch (error) {
            date = null;
        }

        return date;
    }
});
/* eslint-enable */ 